/*
  * This is the main store file
  * To use the Global module state reset
  * this.$store.dispatch('reset'); in any component
*/
import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";
import modules from "./modules";

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";

export const store = new Vuex.Store({
    //export default new Vuex.Store({
    modules,
    actions: {
        reset({ commit }) {
            // resets state of all the modules
            Object.keys(modules).forEach((moduleName) => {
                commit(`${moduleName}/RESET`);
            });
        },
    },
    strict: debug,
    plugins: debug ? [createLogger()] : [], // set logger only for development
});
